<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：状态列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleStateSelect('')"
              :class="{ 'selected': inoutOrderManageInfo.conditions.state === '' }">
              全部
            </li>
            <li v-for="(item, index) in inoutOrderManageInfo.states" :key="index"
              @click="handleStateSelect(item.statusCd)"
              :class="{ 'selected': inoutOrderManageInfo.conditions.state === item.statusCd }">
              {{ item.name }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form :inline="true" :model="inoutOrderManageInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input
                v-model="inoutOrderManageInfo.conditions.personName"
                placeholder="请输入申请人名称"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="inoutOrderManageInfo.conditions.orderId"
                placeholder="请输入单号"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="inoutOrderManageInfo.conditions.queryStartTime"
                type="date"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                clearable
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="inoutOrderManageInfo.conditions.queryEndTime"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                clearable
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryInoutOrderMethod">
                <i class="el-icon-search"></i> 查询
              </el-button>
              <el-button @click="_resetInoutOrderMethod">
                <i class="el-icon-refresh"></i> 重置
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 出库单信息表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>出库单信息</span>
          </div>
          <el-table
            :data="inoutOrderManageInfo.inoutOrders"
            border
            style="width: 100%"
          >
            <el-table-column prop="orderId" label="订单ID" align="center" />
            <el-table-column prop="prodName" label="商品" align="center" />
            <el-table-column prop="personName" label="申请人" align="center" />
            <el-table-column prop="createTime" label="创建时间" align="center" />
            <el-table-column prop="remark" label="备注" align="center" />
            <el-table-column prop="stateName" label="状态" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.state=='5005'"
                  type="text"
                  size="small"
                  @click="_doOrderIn(scope.row)"
                >出库</el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="_toDetail(scope.row)"
                >详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="margin-top:20px;text-align:right"
            @current-change="handleCurrentChange"
            :current-page="inoutOrderManageInfo.conditions.page"
            :page-size="inoutOrderManageInfo.conditions.row"
            layout="total, prev, pager, next"
            :total="inoutOrderManageInfo.total"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryInoutOrder } from '@/api/goods/outOrderApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'OutOrderManage',
  data() {
    return {
      inoutOrderManageInfo: {
        inoutOrders: [],
        total: 0,
        records: 1,
        states: [],
        conditions: {
          personName: '',
          orderId: '',
          shopId: '',
          orderType: '20000',
          state: '',
          queryStartTime: '',
          queryEndTime: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.inoutOrderManageInfo.conditions.shopId = getShopId()
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      await this._listInoutOrders(1, 10)
      try {
        const {data} = await getDict('inout_order', 'state')
        this.inoutOrderManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listInoutOrders(page, rows) {
      this.inoutOrderManageInfo.conditions.page = page
      this.inoutOrderManageInfo.conditions.row = rows
      const params = {
        ...this.inoutOrderManageInfo.conditions,
        orderId: (this.inoutOrderManageInfo.conditions.orderId || '').trim(),
        personName: (this.inoutOrderManageInfo.conditions.personName || '').trim()
      }
      
      try {
        const res = await queryInoutOrder(params)
        this.inoutOrderManageInfo.total = res.total || 0
        this.inoutOrderManageInfo.records = res.records || 0
        this.inoutOrderManageInfo.inoutOrders = res.data || []
      } catch (error) {
        console.error('获取出库单列表失败:', error)
        this.$message.error('获取出库单列表失败')
      }
    },
    _queryInoutOrderMethod() {
      this._listInoutOrders(1, 10)
    },
    _resetInoutOrderMethod() {
      this.inoutOrderManageInfo.conditions.personName = ''
      this.inoutOrderManageInfo.conditions.orderId = ''
      this.inoutOrderManageInfo.conditions.queryStartTime = ''
      this.inoutOrderManageInfo.conditions.queryEndTime = ''
      this._listInoutOrders(1, 10)
    },
    handleStateSelect(state) {
      this.inoutOrderManageInfo.conditions.state = state
      this.inoutOrderManageInfo.conditions.page = 1
      this._listInoutOrders(1, this.inoutOrderManageInfo.conditions.row)
    },
    _toDetail(inoutOrder) {
      this.$router.push(`/pages/goods/upShopHouseDetail?orderId=${inoutOrder.orderId}`)
    },
    _doOrderIn(inoutOrder) {
      this.$router.push(`/pages/goods/doOrderDetailOut?orderId=${inoutOrder.orderId}`)
    },
    handleCurrentChange(val) {
      this._listInoutOrders(val, this.inoutOrderManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.margin-top-sm {
  margin-top: 20px;
}
</style>